<!--
 * @Author: wangwei
 * @Date: 2021-01-09 10:28:06
 * @LastEditTime: 2021-02-01 11:17:01
 * @LastEditors: Please set LastEditors
 * @Description: 首页开屏图
 * @FilePath: /java-pc/src/components/OpenScreen.vue
-->
<template>
  <div class="sld_open_screen" :style="{ height: height + 'px' }" v-if="advInfo.adStyle != 'bottom'" @click="close" >
    <div class="image">
      <!-- <img class="pointer" :src="openScreenData.imgUrl" @click="diyNavTo(openScreenData)" alt=""> -->
      <img class="pointer" :src="advImg" alt="" @click.stop="dragEvent(advData),diyNavTo(advInfo)">
      <div class="close" @click="close"><span>×</span></div>
    </div>
  </div>
  <div class="sld_open_screen" :style="{ height: height + 'px' }"
    style="justify-content: flex-end; flex-direction: column;overflow-x:auto;" v-if="advInfo.adStyle == 'bottom'" >
    <div class="image" style="width: 1920px; height: 600px; ">
      <!-- <img class="pointer" :src="openScreenData.imgUrl" @click="diyNavTo(openScreenData)" alt=""> -->
      <img class="pointer"
        :src="advImg"
        alt=""  @click="diyNavTo(advInfo)">
      <div class="close" @click="close" style="top: -52px; right: 0;"><span>×</span></div>

    </div>
  </div>

</template>

<script>
import { getCurrentInstance, ref } from 'vue'
import { useRoute } from "vue-router";
export default {
  name: 'OpenScreen',
  props: {
    advImg: String,//装修的数据
    advInfo:Object,
    advData:Object,
  },
  components: {

  },
  setup(props, { emit }) {
    const route = useRoute();
    const { proxy } = getCurrentInstance();
    const close_layer_icon = require('@/assets/coupon/close_layer_icon.png')
    const height = ref(document.documentElement.clientHeight)
    const close = () => {
      emit('closeScreen')
    }
    // window.scroll(0, 0)
    const diyNavTo = (val) => {
      proxy.$diyNavTo(val)
    }
    const dragEvent = (item) =>{
      let params = {
					banner_id: item.advId,
					banner_name: item.data.imgName,
					amall_element_id: 0,
					page_path: route.path,
					page_url: item.data.link_type || item.data.url_type,
					page_type: 1
				}
			proxy.$drgStatEvent('banner_click',params)
    }
    return { close_layer_icon, close, diyNavTo, height ,dragEvent}
  }
}
</script>

<style lang="scss" scoped>
.sld_open_screen {
  position: fixed;
  background: rgba(0, 0, 0, .4);
  min-width: 100vw;          /* 最小宽度为视口宽度的 100% */
  height: 100%;
  min-height: 100vh;         /* 最小高度为视口高度的 100% */
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  .image {
    width: 400px;
    height: 600px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      // max-width: 100%;
      // max-height: 100%;
      width: 100%;
      height: 100%;
    }

    .close {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      width: 40px;
      height: 40px;
      top: 0;
      right: -50px;
      z-index: 2;
      cursor: pointer;
      color: #FFFFFF;

      border: 2px solid #FFFFFF;
      border-radius: 50%;

      span {
        line-height: 25px;
        font-weight: 200;
        font-size: 37px;
        width: 30px;
        height: 30px;
      }
    }
  }


}
</style>